import { render, staticRenderFns } from "./SvgInternet.vue?vue&type=template&id=3b39ac0d"
import script from "./SvgInternet.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgInternet.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports